// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a149afaa","52":"cdd0856e","53":"46cce250","197":"2ea9746d","337":"d59f5216","477":"2b01fd38","587":"877b4048"}[chunkId] + ".js";
};